import { createSlice } from '@reduxjs/toolkit';
import { ChangePass, ConfirmPassword, getUserDetails, SendEmail, userLogin, VerifyToken } from 'services/store/actions/authAction';

interface AuthState {
    loading: boolean;
    userInfo: any; // Define the type of userInfo
    error: any; // Define the type of error
    success: boolean;
    //confirm email
    loading1: boolean;
    emailInfo: any;
    error1: any;
    success1: boolean;
    //verify token
    loading3: boolean;
    tokenInfo: any;
    error3: any;
    success3: boolean;
    //reset pass
    loading4: boolean;
    resetpassInfo: any;
    error4: any;
    success4: boolean;
    //change password
    loading5: boolean;
    changePassInfo: any;
    error5: any;
    success5: boolean;
    loading6: boolean;
    error6: any;
    success6: boolean;
    userDetailInfo: any;
}

const initialState: AuthState = {
    loading: false,
    userInfo: null,
    error: null,
    success: false,
    //confirm email
    loading1: false,
    emailInfo: null,
    error1: null,
    success1: false,
    //verify token
    loading3: false,
    tokenInfo: null,
    error3: null,
    success3: false,
    //reset pass
    loading4: false,
    resetpassInfo: null,
    error4: null,
    success4: false,
    //changepass
    loading5: false,
    changePassInfo: null,
    error5: null,
    success5: false,
    loading6: false,
    error6: null,
    success6: false,
    userDetailInfo: null,
};

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {},
    extraReducers: (builder: any) => {
        builder
            .addCase(userLogin.pending, (state: any) => {
                state.loading = true;
                state.error = null;
                state.success = false;
                state.userInfo = null;
            })
            .addCase(userLogin.fulfilled, (state: any, { payload }: any) => {
                state.loading = false;
                state.userInfo = payload;
                state.success = true;
            })
            .addCase(userLogin.rejected, (state: any, { payload }: any) => {
                state.loading = false;
                state.error = payload;
                state.success = false;
            })
            .addCase(SendEmail.pending, (state: any) => {
                state.loading1 = true;
                state.error1 = null;
                state.success1 = false;
            })
            .addCase(SendEmail.fulfilled, (state: any, { payload }: any) => {
                state.loading1 = false;
                state.emailInfo = payload;
                state.success1 = true;
            })
            .addCase(SendEmail.rejected, (state: any, { payload }: any) => {
                state.loading1 = false;
                state.error1 = payload;
                state.success1 = false;
            })
            .addCase(VerifyToken.pending, (state: any) => {
                state.loading3 = true;
                state.error3 = null;
                state.success3 = false;
            })
            .addCase(VerifyToken.fulfilled, (state: any, { payload }: any) => {
                state.loading3 = false;
                state.tokenInfo = payload;
                state.success3 = true;
            })
            .addCase(VerifyToken.rejected, (state: any, { payload }: any) => {
                state.loading3 = false;
                state.error3 = payload;
                state.success3 = false;
            })
            .addCase(ConfirmPassword.pending, (state: any) => {
                state.loading4 = true;
                state.error4 = null;
                state.success4 = false;
            })
            .addCase(ConfirmPassword.fulfilled, (state: any, { payload }: any) => {
                state.loading4 = false;
                state.resetpassInfo = payload;
                state.success4 = true;
            })
            .addCase(ConfirmPassword.rejected, (state: any, { payload }: any) => {
                state.loading4 = false;
                state.error4 = payload;
                state.success4 = false;
            })
            .addCase(ChangePass.pending, (state: any) => {
                state.loading5 = true;
                state.error5 = null;
                state.success5 = false;
            })
            .addCase(ChangePass.fulfilled, (state: any, { payload }: any) => {
                state.loading5 = false;
                state.changePassInfo = payload;
                state.success5 = true;
            })
            .addCase(ChangePass.rejected, (state: any, { payload }: any) => {
                state.loading5 = false;
                state.error5 = payload;
                state.success5 = false;
            })
            .addCase(getUserDetails.pending, (state: any) => {
                state.loading6 = true;
                state.error6 = null;
                state.success6 = false;
                state.userProfileInfo=null;
            })
            .addCase(getUserDetails.fulfilled, (state: any, { payload }: any) => {
                state.loading6 = false;
                state.userProfileInfo = payload;
                state.success6 = true;
            })
            .addCase(getUserDetails.rejected, (state: any, { payload }: any) => {
                state.loading6 = false;
                state.error6 = payload;
                state.success6 = false;
            });
    },
});

export default authSlice.reducer;
